import React from 'react';
import PropTypes from 'prop-types';

const icon = (
    <svg height="24" viewBox="0 0 22 27" xmlns="http://www.w3.org/2000/svg">
        <g fill="currentColor" fillRule="evenodd" stroke="currentColor">
            <path d="M13.24.975l4.52-.147 3.282 3.395-.176 4.637-10.8 11.168-7.624-7.885z" />
            <path d="M11.92 7.775l4.518-.146 3.283 3.392-.174 4.637-10.8 11.167-7.624-7.885z" />
        </g>
    </svg>
);

export default class OverlayImage extends React.Component {
    render() {
        const hasValue = Boolean(this.props.defaultValue);
        const hasTags = Boolean(this.props.tags && this.props.tags.length);
        const Clickable = this.props.onImageClick ? 'a' : 'div';
        return (
            <div className="profile companyprofile">
                <Clickable
                    className="image-frame profilebg fluid block u-position-relative u-overflow-hidden"
                    href="#"
                    onClick={this.props.onImageClick}
                    style={{ backgroundImage: `url(${this.props.imgSrc})` }}
                >
                    {this.props.children}
                    {(hasValue || hasTags) && (
                        <div className="bottomify u-text-center">
                            <div className="overlay-image-text trans-background panel--kill-last-margin">
                                <div className="form-grid">
                                    {hasValue && (
                                        <div className="form-grid__unit form-grid__unit--g1">
                                            <p>{this.props.defaultValue}</p>
                                        </div>
                                    )}
                                    {hasTags && (
                                        <div
                                            className="form-grid__unit form-grid__unit--g0 tooltip-boundary"
                                            title={this.props.tags.join(', ')}
                                        >
                                            {icon}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                </Clickable>
            </div>
        );
    }
}

OverlayImage.propTypes = {
    onImageClick: PropTypes.func,
    defaultValue: PropTypes.string,
    tags: PropTypes.arrayOf(PropTypes.string),
    imgSrc: PropTypes.string,
};
